import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ConfigETC from "../Class/ConfigETC.json";
import SelectDepartment from "../Library/Select_Department";
import { Class_ETC_Decrypt } from "../Class/Class_Etc";
import Pathurl from "../Class/Pathurl.json";
import { updateSampleSection } from "../Main/Sample-base";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";

import PaginationActions from "../PartialView/PaginationActions";
import { CP_CheckPermission } from "../Class/Class_Permission";

/*

  Edit BY POOM : 09-05-2024 
  - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล

  Edit BY POOM : 15-05-2024 
  - เพิ่ม Rate PER DIEM(Baht/day) , Rate travel(Baht/km.)

*/

function PV_Organization(props) {

  const location = useLocation();
  const isSVOT = CP_CheckPermission("service_list" , ["ot"] ,false ,false);
  const isService_department = CP_CheckPermission("service_list",["department"],false,false);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [searchDepartment, setSearchDepartment] = useState(null);
  const [pgProid, setPgProid] = useState(-1);
  const [isFirst, setIsFirst] = useState(true);
  const [listdata, setListdata] = useState([]);
  const [listdataDep, setListdataDep] = useState([]);
  const [page, setPage] = useState(0);
  const [page_all, setPage_all] = useState(0);
  // eslint-disable-next-line
  const [rowsPerPage, setRowsPerPage] = useState(ConfigETC.rowsPerPage); //
  // eslint-disable-next-line
  const [rowsPerPage_all, setRowsPerPage_all] = useState(ConfigETC.rowsPerPage); //
  const [colSpan, setColSpan] = useState(7);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage_all = (event) => {
    setPage_all(0);
  };

  const handleChangePage_all = (event, newPage) => {
    setPage_all(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
  };

  //#region __ Box ส่วนบน Project __
  function GetParameter(_callback) {
    let isNullParameter = false;
    let proid = "";

    try {
      if (location.state === null) {
        isNullParameter = true;
      } else {
        proid = Class_ETC_Decrypt(location.state?.proid.toString());

        if (proid === "") {
          isNullParameter = true;
        }
      }
    } catch {
      isNullParameter = true;
    }

    if (isNullParameter) {
      window.location.replace("../" + Pathurl.m_project_view);
      if (_callback != null) {
        _callback();
      }
    } else {
      setPgProid(proid);

      if (_callback != null) {
        _callback();
      }
    }
  }
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }
  //#endregion

  //#region useEffect
  useEffect(() => {
    if (isFirst === true) {
      GetParameter(function () {
        GetConfig();
        props.PermissionCostView ? setColSpan(colSpan - 2) : setColSpan (setColSpan -0);


        if (isLoadedConfigData === true) {
          BindList(pgProid, "-1", function () {
            setIsLoadProgress(false);
            setIsFirst(false);
          });
        }
        updateSampleSection();
      });
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  useEffect(() => {
    if (searchDepartment != null) {
      BindListDepartment(
        pgProid,
        searchDepartment.value.toString(),
        function () {
          setIsLoadProgress(false);
        }
      );
    }
    // eslint-disable-next-line
  }, [searchDepartment]);

  //#endregion

  //#region __Bind Data
  async function BindList(pro_id, pro_dept_id, _callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        pro_id: pro_id,
        pro_dept_id: pro_dept_id,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_Org_GetListByDepartment",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListdata(json.data);

          if (_callback != null) {
            _callback();
          }
        } else {
          // setPage(0);
          setListdata([]);
          if (_callback != null) {
            _callback();
          }
        }
      }
      else
      {
        setListdata([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      // setPage(0);
      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindListDepartment(pro_id, pro_dept_id, _callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        pro_id: pro_id,
        pro_dept_id: pro_dept_id,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_Org_GetListByDepartment",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListdataDep(json.data);
          if (_callback != null) {
            _callback();
          }
        } else {
          // setPage(0);
          setListdataDep([]);
          if (_callback != null) {
            _callback();
          }
        }
      }
      else
      {
        setListdataDep([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      // setPage(0);
      setListdataDep([]);
      if (_callback != null) {
        _callback();
      }
    }
  }
  //end region

  //#region Custom Function
  function SelectFirstTime(pro_dept_id) {
    BindListDepartment(pgProid, pro_dept_id.toString(), function () {
      setIsLoadProgress(false);
    });
  }

  function SearchonChangevalueDepartment(e) {
    setSearchDepartment(e);
  }

  //#endregion

  return (
    <>
      {/* Start Over View Detail */}

      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <div>
        {/* /.card-header */}
        <div className="card-body border-0 m-0 p-0">
          <div className="card ">
            <div className="card-header p-0 border-bottom-0">
              <ul
                className="nav nav-tabs"
                id="custom-tabs-four-tab"
                role="tablist"
              >
                {isService_department && 
                <>
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      id="custom-tabs-four-all-tab"
                      data-toggle="pill"
                      href="#custom-tabs-four-all"
                      role="tab"
                      aria-controls="custom-tabs-four-all"
                      // aria-selected="true"
                    >
                      ALL
                    </a>
                  </li>
                </>
                }
                <li className="nav-item">
                  <a
                    className={"nav-link" + (isService_department === false ? " active" : "")}
                    id="custom-tabs-four-home-tab"
                    data-toggle="pill"
                    href="#custom-tabs-four-home"
                    role="tab"
                    aria-controls="custom-tabs-four-home"
                    // aria-selected="true"
                  >
                   Project Organization
                  </a>
                </li>
              </ul>
            </div>
            <div className="card-body m-0 p-0">
              <div className="tab-content" id="custom-tabs-four-tabContent">
                <div
                  className={"tab-pane fade show" + (isService_department === true ? " active" : "")}
                  id="custom-tabs-four-all"
                  role="tabpanel"
                  aria-labelledby="custom-tabs-four-all-tab"
                >
                  <TableContainer>
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      className="table table-head-fixed  table-hover table-sm"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{
                              width: "3%",
                              backgroundColor: "#f9f9f9",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-center align-middle"
                          >
                            #
                          </TableCell>
                          <TableCell
                            style={{
                              width: "15%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-left align-middle"
                          >
                            Department{" "}
                          </TableCell>
                          <TableCell
                            style={{
                              width: "15%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-left align-middle"
                          >
                            Position{" "}
                          </TableCell>
                          <TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-left align-middle"
                          >
                            Staff{" "}
                          </TableCell>
                          {props.PermissionCostView &&(<TableCell
                            style={{
                              width: "23%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            colSpan={(isSVOT === true ? 4 : 3)}
                            className="border-0 p-1 text-center  align-top"
                          >
                            Rate 
                          </TableCell>)}
                          
                          <TableCell
                            style={{
                              width: "24%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            colSpan={2}
                            className="border-0 p-1 text-center  align-top"
                          >
                            Authority
                          </TableCell>

                          
                         

                        </TableRow>
                        <TableRow style={{ backgroundColor: "#f9f9f9" }}>
                        {props.PermissionCostView &&(<TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            className="border-0 p-1 text-left text-sm align-top"
                           
                          >
                            Work time <br />
                            <small>(Baht/hr.)</small>
                          </TableCell>)}

                        {props.PermissionCostView && isSVOT &&( <TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            className="border-0 p-1  text-left text-sm align-top"
                          >
                            Over time<br />
                            <small>(Baht/hr.)</small>
                          </TableCell>)}
                          <TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-left align-top"
                          >
                           Per diem allowance
                           <br />
                            <small>(Baht/day)</small>
                          </TableCell>
                          <TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-left align-top"
                          >
                            Travel
                            <br />
                            <small>(Baht/km.)</small>
                          </TableCell>
                         
                          <TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            className="text-center text-sm align-top"
                          >
                            Timesheet
                          </TableCell>

                          <TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            className="text-center text-sm align-top"
                          >
                            Timeoff
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(listdata.length === 0 && (
                          <TableRow key={99}>
                            <TableCell colSpan={colSpan} align="center">
                              {ConfigETC.NoData}
                            </TableCell>
                          </TableRow>
                        )) ||
                          listdata
                          .slice(
                            page_all * rowsPerPage_all,
                            page_all * rowsPerPage_all + rowsPerPage_all
                          )
                          .map((row) => (
                            <TableRow key={row.rowindex}>
                              <TableCell>{row.rowindex}</TableCell>
                              <TableCell>
                                <div>{row.dept_name}</div>
                              </TableCell>
                              <TableCell>
                                <div>{row.position_name}</div>
                              </TableCell>
                              <TableCell>
                                {row.count_staff > 0 && (
                                  <>
                                    <a
                                      href="#!"
                                      className="text-bold text-black"
                                      data-toggle="pill"
                                      title="Click for view detail"
                                      onClick={() => props.onclick_Organization_staff(row.pro_dept_id , row.pro_pos_id , row.dept_name , row.position_name)}
                                    >
                                      <span className="btn btn-primary btn-xs ">
                                        <i className="fas fa-user" />
                                      </span>
                                    </a>{" "}
                                       <b> {row.count_staff}</b>{" "}<small>staffs</small>

                                  </>
                                )}
                              </TableCell>
                              {props.PermissionCostView &&( <TableCell>
                                <div>
                                  {(row.rate_normal_hours_str === "0.00" &&
                                    "") ||
                                    (row.rate_normal_hours_str !== "0.00" &&
                                      row.rate_normal_hours_str)}
                                </div>
                              </TableCell>)}
                              {props.PermissionCostView &&  isSVOT === true && 
                              ( <TableCell>
                                <div>
                                  {(row.rate_ot_str === "0.00" && "") ||
                                    (row.rate_ot_str !== "0.00" &&
                                      row.rate_ot_str)}{" "}
                                </div>
                              </TableCell>
                              )}
                             
                              <TableCell>
                                <div>
                                  {(row.pos_rate_exp_extra_str === "0.00" ? "" : row.pos_rate_exp_extra_str)}
                                </div>
                              </TableCell>
                              <TableCell>
                                <div>
                                  {(row.pos_rate_exp_travel_str === "0.00" ? "" : row.pos_rate_exp_travel_str)}
                                </div>
                              </TableCell>

                              <TableCell className="text-center">
                                <span
                                  className={
                                    row.authority_timesheet === 0
                                      ? ConfigETC.Timesheet_None
                                      : row.authority_timesheet === 1
                                      ? ConfigETC.Timesheet_Reviewer
                                      : row.authority_timesheet === 2
                                      ? ConfigETC.Timesheet_Approver
                                      : ConfigETC.Timesheet_SelfApprove
                                  }
                                >
                                  {row.authority_timesheet_str}
                                </span>
                              </TableCell>

                              <TableCell className="text-center">
                                <span
                                  className={
                                    row.authority_timeoff === 0
                                      ? ConfigETC.Timeoff_None
                                      : row.authority_timeoff === 1
                                      ? ConfigETC.Timeoff_Reviewer
                                      : row.authority_timeoff === 2
                                      ? ConfigETC.Timeoff_Approver
                                      : ConfigETC.Timeoff_SelfApprove
                                  }
                                >
                                  {row.authority_timeoff_str}
                                </span>
                              </TableCell>
                              
                            

                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {listdata.length > 0 && (
                          <TablePagination
                            rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                            component="div"
                            count={listdata.length}
                            rowsPerPage={rowsPerPage_all}
                            page={page_all}
                            onPageChange={handleChangePage_all}
                            onRowsPerPageChange={handleChangeRowsPerPage_all}
                            ActionsComponent={PaginationActions}
                          />
                        )}

                </div>
                <div
                  className={"tab-pane fade show" + (isService_department === false ? " active" : "")}
                  id="custom-tabs-four-home"
                  role="tabpanel"
                  aria-labelledby="custom-tabs-four-home-tab"
                >
                  <div className="row m-0">
                    <div className="col-6">
                      <div className="form-group ml-5 mt-2">
                        
                        <label className="text-small p-0 m-0">Department</label>
                        {isLoadedConfigData && (
                          <SelectDepartment
                            API_URL={configData.API_URL}
                            pro_id={pgProid}
                            selectismulti={false}
                            SelectTextDefault=""
                            resetSelect={null}
                            onChangevalue={SearchonChangevalueDepartment}
                            iscloseMenuOnSelect={true}
                            isSelectFistTime={true}
                            SelectFirstTime={SelectFirstTime}
                          ></SelectDepartment>
                        )}

                        <input type="hidden" id="hd_SelectSOC"></input>
                      </div>
                    </div>
                  </div>

                  {/*Start Here*/}
                  <TableContainer>
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      className="table table-head-fixed  table-hover table-sm"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{
                              width: "3%",
                              backgroundColor: "#f9f9f9",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-center align-middle"
                          >
                            #
                          </TableCell>

                          <TableCell
                            style={{
                              width: "15%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-left align-middle"
                          >
                            Position{" "}
                          </TableCell>
                          <TableCell
                            style={{
                              width: "15%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-left align-middle"
                          >
                            Staff{" "}
                          </TableCell>
                          {props.PermissionCostView &&(<TableCell
                            style={{
                              width: "23%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                           
                            className="border-0 p-1 text-center  align-top"
                            colSpan={(isSVOT === true ? 4 : 3)}
                          >
                            Rate 
                          </TableCell>)}
                          
                          <TableCell
                            style={{
                              width: "24%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            colSpan={2}
                            className="border-0 p-1 text-center  align-top"
                          >
                            Authority
                          </TableCell>


                          

                        </TableRow>
                        <TableRow style={{ backgroundColor: "#f9f9f9" }}>
                        {props.PermissionCostView &&(<TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            className="border-0 p-1 text-left text-sm align-top"
                           
                          >
                            Work time<br/><small>(Baht/hr.)</small>
                          </TableCell>)}
                        {props.PermissionCostView && isSVOT &&(<TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            className="border-0 p-1 text-left text-sm align-top"
                          >
                            Over time<br/><small>(Baht/hr.)</small>
                          </TableCell>)}
                          <TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-left align-middle"
                          >
                            Per diem allowance
                            <br/><small>(Baht/day)</small>
                            
                          </TableCell>
                          <TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            rowSpan={2}
                            className="border-0 p-1 text-left align-middle"
                          >
                            Travel
                            <br/><small>(Baht/km.)</small>
                          </TableCell>
                          
                          <TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            className="text-center text-sm align-top"
                          >
                            Timesheet
                          </TableCell>

                          <TableCell
                            style={{
                              width: "10%",
                              backgroundColor: "#f9f9f9",
                              fontWeight: "bold",
                            }}
                            className="text-center text-sm align-top"
                          >
                            Timeoff
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(listdataDep.length === 0 && (
                          <TableRow key={99}>
                            <TableCell colSpan={colSpan} align="center">
                              {ConfigETC.NoData}
                            </TableCell>
                          </TableRow>
                        )) ||
                          listdataDep
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow key={row.rowindex}>
                                <TableCell>{row.rowindex}</TableCell>

                                <TableCell>
                                  <div>{row.position_name}</div>
                                </TableCell>
                                <TableCell>
                                  {row.count_staff > 0 && (
                                    <>
                                      <a
                                        href="#!"
                                        className="text-bold text-black"
                                        data-toggle="pill"
                                        title="Click for view detail"
                                        onClick={() => props.onclick_Organization_staff(row.pro_dept_id , row.pro_pos_id , row.dept_name , row.position_name)}
                                      >
                                        <span className="btn btn-primary btn-xs ">
                                          <i className="fas fa-user" />
                                        </span>
                                      </a>
                                      {" "}
                                       <b> {row.count_staff}</b>{" "}<small>staffs</small>
                                    </>
                                  )}
                                </TableCell>
                                {props.PermissionCostView &&(<TableCell>
                                  {(row.rate_normal_hours_str === "0.00" &&
                                    "") ||
                                    (row.rate_normal_hours_str !== "0.00" &&
                                      row.rate_normal_hours_str)}
                                </TableCell>)}
                                {props.PermissionCostView &&  isSVOT === true && 
                                (<TableCell>
                                  <div>
                                    {(row.rate_ot_str === "0.00" && "") ||
                                      (row.rate_ot_str !== "0.00" &&
                                        row.rate_ot_str)}{" "}
                                  </div>
                                </TableCell>)}
                                
                                <TableCell>
                                  <div>
                                    {(row.pos_rate_exp_extra_str === "0.00" ? "" : row.pos_rate_exp_extra_str)}
                                  </div>
                                </TableCell>
                                <TableCell>
                                  <div>
                                    {(row.pos_rate_exp_travel_str === "0.00" ? "" : row.pos_rate_exp_travel_str)}
                                  </div>
                                </TableCell>
                                <TableCell className="text-center">
                                  <span
                                    className={
                                      row.authority_timesheet === 0
                                        ? ConfigETC.Timesheet_None
                                        : row.authority_timesheet === 1
                                        ? ConfigETC.Timesheet_Reviewer
                                        : row.authority_timesheet === 2
                                        ? ConfigETC.Timesheet_Approver
                                        : ConfigETC.Timesheet_SelfApprove
                                    }
                                  >
                                    {row.authority_timesheet_str}
                                  </span>
                                </TableCell>

                                <TableCell className="text-center">
                                  <span
                                    className={
                                      row.authority_timeoff === 0
                                        ? ConfigETC.Timeoff_None
                                        : row.authority_timeoff === 1
                                        ? ConfigETC.Timeoff_Reviewer
                                        : row.authority_timeoff === 2
                                        ? ConfigETC.Timeoff_Approver
                                        : ConfigETC.Timeoff_SelfApprove
                                    }
                                  >
                                    {row.authority_timeoff_str}
                                  </span>
                                </TableCell>

                                



                              </TableRow>
                            ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {listdata.length > 0 && (
                    <TablePagination
                      rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                      component="div"
                      count={listdata.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={PaginationActions}
                    />
                  )}
                  {/*End Here */}
                 
                </div>
              </div>
            </div>
            {/* /.card */}
          </div>
        </div>
        {/* /.card-body */}
        {/* /.card-footer*/}
      </div>
    </>
  );
}

export default PV_Organization;
